<template>
  <div>
    <CreateRentalPayment ref="createRentalPayment"></CreateRentalPayment>
    <!-- <ProcessPendingRentalPayments ref="processPendingRentalPayments"></ProcessPendingRentalPayments> -->
  </div>
</template>

<script>
import CreateRentalPayment from './CreateRentalPayment.vue'
// import ProcessPendingRentalPayments from './ProcessPendingRentalPayments.vue'

export default {
  components: {
    CreateRentalPayment
    // ProcessPendingRentalPayments,
  },
  // data() {
  //   return {
  //     pendingRentalPayments: [],
  //   }
  // },
  computed: {
    pendingRentalPayments() {
      return this.$store.getters['payments/getPendingRentalPayments']
    }
  },
  async mounted() {
    // await this.$store.dispatch('payments/fetchPendingRentalPaymentsAction')
  },
  methods: {
    async open(lease) {
      // temporarily disable this function
      // await this.$store.dispatch('payments/fetchPendingRentalPaymentsAction')
      // const filteredPayments = this.pendingRentalPayments.filter(payment => {
      //   return payment.leaseId === lease.leaseId
      // })
      // if(filteredPayments.length) {
      //   return this.$refs.processPendingRentalPayments.open({lease: lease, payments: filteredPayments}).then(async success => {
      //     await this.$store.dispatch('payments/fetchPendingRentalPaymentsAction')
      //     return success
      //   })
      // }
      // else {
      return this.$refs.createRentalPayment.open(lease)
      // }
    }
  }
}
</script>
